import { Component, OnInit, AfterViewInit, Injectable } from '@angular/core';
import { Location } from '@angular/common';

declare var $;

export class instiLoading{
   /**
   * ==============================================
   * DECLARATIONS
   * ==============================================
   */ 
  is_loading: boolean=true;
  storage_name:string ;//:string ='loading_inst';
  from_storage=false;
  constructor(){
      this.storage_name='loading_inst';
  }
 
   getStorageName(){ return this.storage_name;}
   getIsLoading(){
    let instance = this;
  
    if(this.from_storage!==true){
        return this.is_loading;
    }
     var a=JSON.parse(localStorage.getItem(instance.getStorageName())); 
    return a;
  }
  setIsLoading(value: boolean){
    let instance = this;
    this.is_loading=value;
    if(this.from_storage!==true){
        return this;
    }
     localStorage.setItem(instance.getStorageName(), JSON.stringify(instance.is_loading)); 
    return this;
  }
} 